var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRepeat = function SvgArrowRepeat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 7.66678L5.33333 5.33344M5.33333 5.33344L3 7.66678M5.33333 5.33344V12.3334C5.33333 14.0517 6.72623 15.4446 8.44444 15.4446L10 15.4446M12.3333 12.3334L14.6667 14.6668M14.6667 14.6668L17 12.3334M14.6667 14.6668V7.66678C14.6667 5.94856 13.2738 4.55566 11.5556 4.55566L10 4.55566",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgArrowRepeat;